import { Spacer, VDBText } from "@components/atoms";
import { useTheme } from "styled-components/native";
import { View } from "react-native";
import { useState } from "react";
import styled from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { TouchableOpacity } from "react-native-gesture-handler";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import Locations from "@components/molecules/Locations/LocationModal";
import { RenderLocationViewProps } from "./types";
import { useTranslation } from "react-i18next";
import { SpaceType } from "@components/atoms/Spacer/types";
import { VDBIcons } from "@utils/VDBIcons";

const RenderLocationView = ({
  itemDetail,
  location,
  updateSelection,
  isPrimary,
  localLocation,
}: RenderLocationViewProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();

  const [localSelectedLocation, setLocalSelectedLocation] =
    useState(localLocation);

  const [otherSelectedLocation, setOtherSelectedLocation] =
    useState(localLocation);

  const [isSelectLocationOpen, setIsSelectLocationOpen] = useState(false);

  const changeLanguage = (selectedLocation: any) => {
    if (selectedLocation) {
      if (isPrimary) {
        setLocalSelectedLocation(selectedLocation);
      } else {
        setOtherSelectedLocation(selectedLocation);
      }
      updateSelection(isPrimary, selectedLocation);
    }
  };

  return (
    <View>
      <TouchableOpacity
        onPress={() => setIsSelectLocationOpen(!isSelectLocationOpen)}
        disabled={itemDetail?.locations?.length === 1}
      >
        <LocationContainer>
          <RowLocationContainer>
            <VDBIcon
              name={VDBIcons.LOCATION}
              size={24}
              color={theme["core-04"]}
              variant={IconsVariant.VDBCustom}
            />
            <LocationTitleContainer>
              <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
                {t("productDetailPage.popup.locationTitle.text")}
              </VDBText>
              <Spacer size={SpaceType.ExtraSmall} />
              <VDBText
                selectable={false}
                ellipsizeMode="tail"
                numberOfLines={1}
                type={typography["Body-M"]}
                color={theme["core-05"]}
              >
                {location}
              </VDBText>
            </LocationTitleContainer>
            {itemDetail?.locations?.length !== 1 && (
              <VDBIcon
                name={VDBIcons.FILLED_CIRCLE_DOWN}
                size={24}
                color={theme["extra-01"]}
                variant={IconsVariant.VDBCustom}
              />
            )}
          </RowLocationContainer>
        </LocationContainer>
      </TouchableOpacity>
      <Locations
        isOpen={isSelectLocationOpen}
        onClose={() => setIsSelectLocationOpen(false)}
        languages={itemDetail?.locations}
        selectedLocation={
          isPrimary ? localSelectedLocation : otherSelectedLocation
        }
        changeLocation={changeLanguage}
        isMatchPair={true}
      />
    </View>
  );
};

const LocationContainer = styled.View<any>`
  background-color: ${({ theme }) => theme["core-01"]};
  padding: 4px;
  border-radius: 7px;
  border-color: ${({ theme }) => theme["core-06"]};
  border-width: ${() => "1px"};
  justify-content: center; /* Align children horizontally */
`;

const RowLocationContainer = styled.View`
  flex-direction: row;
  margin: 10px;
  align-items: center;
`;

const LocationTitleContainer = styled.View`
  flex-direction: column;
  margin-left: 5px;
  flex: 1;
`;

export default RenderLocationView;
